import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Phone, MessageCircle, SkipForward, X } from "lucide-react";

export function NextCallCard({ lead, onCalled, onNext, onClose }) {
  if (!lead) return null;
  return (
    <Card className="p-4 bg-emerald-500/10 border-emerald-400/50 flex flex-wrap items-center gap-3" data-testid="next-call-card">
      <div className="mr-auto min-w-0">
        <p className="eyebrow text-emerald-300">Now calling · reserved for {lead.assigned_to}</p>
        <p className="font-serif text-lg text-white mt-1" data-testid="next-call-name">{lead.name || "Unknown"} <span className="font-mono text-gold text-base">+{lead.phone}</span></p>
        <p className="text-xs text-muted-foreground mt-0.5">
          {lead.status.replace("_", " ")}{lead.demand ? ` · ${lead.demand}` : ""}{lead.next_follow_up ? ` · follow-up ${lead.next_follow_up}` : ""} · {lead.call_count || 0} calls
        </p>
      </div>
      <a href={`tel:+${lead.phone}`} onClick={() => onCalled(lead.id)} data-testid="next-call-dial"
        className="inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-emerald-500 text-[#04221a] font-bold text-sm hover:bg-emerald-400"><Phone className="w-4 h-4" /> Call now</a>
      <a href={`https://wa.me/${lead.whatsapp || lead.phone}`} target="_blank" rel="noopener noreferrer" onClick={() => onCalled(lead.id)} data-testid="next-call-wa"
        className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-[#25D366]/20 text-[#25D366] border border-[#25D366]/40 text-sm font-semibold"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
      <Button onClick={onNext} variant="outline" className="h-9 border-gold/40 text-gold gap-1.5" data-testid="next-call-next"><SkipForward className="w-4 h-4" /> Next number</Button>
      <button type="button" onClick={onClose} className="text-muted-foreground hover:text-white" data-testid="next-call-close"><X className="w-4 h-4" /></button>
    </Card>
  );
}
